import * as React from 'react';
import clsx from 'clsx';
import { Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { String_CheckoutComplete_NoReceipt } from '../../utilities/StringHelper';

const useStyles = makeStyles({
    root: {
        height: '100%',
        overflow: 'hidden',
        marginTop: '40px',
        marginLeft: '20px',
        marginRight: '20px',
        textAlign: 'center',
    },
    rootLandscape: {
        marginTop: '0',
        width: 'calc(100vw *.7)',
    },
});

const NoReceipt = () => {
    const isPortrait = true;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color});

    return (
        <div className={clsx(classes.root, {
            [classes.rootLandscape]: !isPortrait,
        })}>
            <Typography variant="h6">
                {String_CheckoutComplete_NoReceipt.find(s => s.key === userState.state.locale)!!.value}
            </Typography>
        </div>
    );
};

export default NoReceipt;